import { Icon } from "@iconify/react";
import { Link, useLocation } from "react-router-dom";
import "./Breadcrumbs.css";

const Breadcrumbs = ({ breadcrumbs }) => {
  const location = useLocation();
  const pathnames = location.pathname.split("/").filter((x) => x); // filter out empty strings

  if (breadcrumbs) {
    return (
      <div className="breadcrumbs">
        {breadcrumbs.map((breadcrumb, index) => (
          <div key={index} className="breadcrumbs__item">
            <span className="breadcrumbs__separator">
              <Icon icon="ant-design:right-outlined" inline />
            </span>
            <Link to={breadcrumb.link} className={`breadcrumbs__link capitalize`}>
              {breadcrumb.name.split("-")}
            </Link>
            {index === breadcrumbs.length - 1 ? (
              <span className="breadcrumbs__separator">
                <Icon icon="ant-design:right-outlined" inline />
              </span>
            ) : null}
          </div>
        ))}
      </div>
    );
  }

  return (
    <>
      {pathnames.length > 0 && (
        <div className="breadcrumbs">
          {pathnames.map((path, index) => (
            <div key={index} className="breadcrumbs__item">
              <span className="breadcrumbs__separator">
                <Icon icon="ant-design:right-outlined" inline />
              </span>
              <Link to={`/${path}`} className={`breadcrumbs__link capitalize`}>
                {path.split("-").join(" ")}
              </Link>
              {index === pathnames.length - 1 ? (
                <span className="breadcrumbs__separator">
                  <Icon icon="ant-design:right-outlined" inline />
                </span>
              ) : null}
            </div>
          ))}
        </div>
      )}
    </>
  );
};
export default Breadcrumbs;
